import {
  LayoutDashboard,
  Boxes,
  Stethoscope,
  Wallet,
  ClipboardList,
  Truck,
  FolderOpen,
  Bell,
  Scale,
  Settings,
  ShoppingBag,
  FileText,
  BarChart3,
  PackageOpen,
  Container,
  type LucideIcon,
} from 'lucide-react-native';

import type { Rol } from '@/types/domain';

export interface RouteDef {
  name: string;
  label: string;
  icon: LucideIcon;
  group: 'principal' | 'gestion' | 'sistema';
  roles: Rol[];
  description?: string;
}

export const ROUTES: RouteDef[] = [
  {
    name: 'Dashboard',
    label: 'Inicio',
    icon: LayoutDashboard,
    group: 'principal',
    roles: ['admin', 'doctor', 'recepcion'],
  },
  {
    name: 'ProductosVenta',
    label: 'Farmacia',
    icon: Boxes,
    group: 'principal',
    roles: ['admin', 'doctor', 'recepcion'],
  },
  {
    name: 'InsumosInternos',
    label: 'Insumos internos',
    icon: Stethoscope,
    group: 'principal',
    roles: ['admin', 'doctor'],
  },
  {
    name: 'Formularios',
    label: 'Formularios',
    icon: FileText,
    group: 'principal',
    roles: ['admin', 'doctor', 'recepcion'],
    description: 'Papeles preimpresos: castración, autorizaciones, vacuna rabia.',
  },
  {
    name: 'Jaulas',
    label: 'Jaulas',
    icon: Container,
    group: 'principal',
    roles: ['admin', 'recepcion'],
    description: 'Jaulas en préstamo: disponibles, prestadas y vencimientos.',
  },
  {
    name: 'Contabilidad',
    label: 'Gastos',
    icon: Wallet,
    group: 'gestion',
    roles: ['admin'],
  },
  {
    name: 'Estadisticas',
    label: 'Estadísticas',
    icon: BarChart3,
    group: 'gestion',
    roles: ['admin'],
    description: 'Gráficas de gastos, categorías, proveedores e inventario.',
  },
  {
    name: 'Petshops',
    label: 'Petshops',
    icon: ShoppingBag,
    group: 'gestion',
    roles: ['admin', 'recepcion'],
  },
  {
    name: 'Solicitudes',
    label: 'Solicitudes',
    icon: ClipboardList,
    group: 'gestion',
    roles: ['admin', 'doctor', 'recepcion'],
  },
  {
    name: 'Proveedores',
    label: 'Proveedores',
    icon: Truck,
    group: 'gestion',
    roles: ['admin'],
  },
  {
    name: 'Comparativa',
    label: 'Comparar precios',
    icon: Scale,
    group: 'gestion',
    roles: ['admin'],
  },
  {
    name: 'Archivos',
    label: 'Archivos clínicos',
    icon: FolderOpen,
    group: 'gestion',
    roles: ['admin'],
  },
  {
    name: 'Alertas',
    label: 'Alertas',
    icon: Bell,
    group: 'sistema',
    roles: ['admin', 'doctor', 'recepcion'],
  },
  {
    name: 'Configuracion',
    label: 'Configuración',
    icon: Settings,
    group: 'sistema',
    roles: ['admin'],
  },
];

export function routesForRole(rol: Rol): RouteDef[] {
  return ROUTES.filter((r) => r.roles.includes(rol));
}
